export const palette = {
    primary: {
        900: { light: '#203352', dark: '#E4EDFF' },
        800: { light: '#355689', dark: '#D3E1FA' },
        700: { light: '#3F67A5', dark: '#C1D3F5' },
        600: { light: '#4A78C1', dark: '#9BB9F0' },
        500: { light: '#5489DC', dark: '#6697E0' },
        400: { light: '#78A4F6', dark: '#6287C5' },
        300: { light: '#AAC4ED', dark: '#5776A9' },
        200: { light: '#BFD3F2', dark: '#4B638E' },
    },
    red: {
        900: { light: '#52151B', dark: '#FFA1A9' },
        800: { light: '#88232E', dark: '#F78C95' },
        700: { light: '#A42A37', dark: '#EF7782' },
        600: { light: '#BF3140', dark: '#E6626F' },
        500: { light: '#DA3849', dark: '#DE4E5C' },
        400: { light: '#E36A77', dark: '#C84A58' },
        300: { light: '#ED9BA4', dark: '#B24551' },
        200: { light: '#F1B4BB', dark: '#9C3E49' },
    },
    green: {
        900: { light: '#1E682E', dark: '#DCFFE3' },
        800: { light: '#1E682E', dark: '#BAF1C5' },
        700: { light: '#247D38', dark: '#9AE3AA' },
        600: { light: '#2A9141', dark: '#7DD490' },
        500: { light: '#30A64A', dark: '#63C678' },
        400: { light: '#94C8A0', dark: '#61B172' },
        300: { light: '#97D2A5', dark: '#5E9D6B' },
        200: { light: '#B1DEBB', dark: '#588862' },
    },
    yellow: {
        900: { light: '#7F6018', dark: '#FFF4DC' },
        800: { light: '#BF9023', dark: '#FFE9B7' },
        700: { light: '#DEA829', dark: '#FFDE92' },
        600: { light: '#F6AD00', dark: '#FED36D' },
        500: { light: '#FEC02F', dark: '#FEC848' },
        400: { light: '#FED77C', dark: '#E1B348' },
        300: { light: '#FFE097', dark: '#C49E45' },
        200: { light: '#FFECAC', dark: '#A78941' },
    },
    neutral1: {
        light: '#000000',
        dark: '#FFFFFF',
    },
    neutral2: {
        light: '#FFFFFF',
        dark: '#000000',
    },
    background: {
        primary: {
            light: '#FFFFFF',
            dark: '#2D2E30',
        },
        secondary: {
            light: '#EEEEEE',
            dark: '#2A2A2A',
        },
        input: {
            light: '#FFFFFF',
            dark: '#555555',
        },
    },
    surface: {
        primary: { light: '#FFFFFF', dark: '#2E2E2E' },
        secondary: { light: '#F9F9F9', dark: '#363638' },
        primary50: { light: '#EAF0FB', dark: '#3D5072' },
        primary100: { light: '#D4E2F6', dark: '#485774' },
        red50: { light: '#FAE6E8', dark: '#6B2F37' },
        red100: { light: '#F6CDD2', dark: '#6C4247' },
        green50: { light: '#E5F4E8', dark: '#475E4C' },
        green100: { light: '#CBE9D2', dark: '#526456' },
        yellow50: { light: '#FFF7E5', dark: '#6E5C32' },
        yellow100: { light: '#FFEFCB', dark: '#776949' },
    },
    content: {
        primary: { light: '#333333', dark: '#CCCCCC' },
        secondary: { light: '#808080', dark: '#BBBBBB' },
        disabled: { light: '#CFCFCF', dark: '#515151' },
        white: { light: '#FFFFFF', dark: '#FFFFFF' },
        black: { light: '#000000', dark: '#000000' },
        buttonText1: { light: '#FFFFFF', dark: '#000000' },
        buttonText2: { light: '#000000', dark: '#000000' },
    },
    border: {
        primary: { light: '#CCCCCC', dark: '#777777' },
        secondary: { light: '#DDDDDD', dark: '#555555' },
    },
    interactive: {
        content: {
            idle: { light: '#CFCFCF', dark: '#777777' },
            hover: { light: '#808080', dark: '#BBBBBB' },
            pressed: { light: '#333333', dark: '#CCCCCC' },
            pressedHover: { light: '#333333', dark: '#CCCCCC' },
            disabled: { light: '#CFCFCF', dark: '#515151' },
        },
        primary: {
            idle: { light: '#5489DC', dark: '#65A5FF' },
            hover: { light: '#2F71D7', dark: '#90BEFF' },
            pressed: { light: '#1353B7', dark: '#B8D4FF' },
            pressedHover: { light: '#1353B7', dark: '#B8D4FF' },
            disabled: { light: '#CFCFCF', dark: '#515151' },
        },
        red: {
            idle: { light: '#DA3849', dark: '#FF6F7D' },
            hover: { light: '#BF3140', dark: '#FFA1A9' },
            pressed: { light: '#A42A37', dark: '#FFB8BF' },
            pressedHover: { light: '#A42A37', dark: '#FFB8BF' },
            disabled: { light: '#CFCFCF', dark: '#515151' },
        },
        green: {
            idle: { light: '#30A64A', dark: '#63C678' },
            hover: { light: '#2A9141', dark: '#8AFFA3' },
            pressed: { light: '#247D38', dark: '#A4FFB8' },
            pressedHover: { light: '#247D38', dark: '#A4FFB8' },
            disabled: { light: '#CFCFCF', dark: '#515151' },
        },
        yellow: {
            idle: { light: '#FEC02F', dark: '#FEC848' },
            hover: { light: '#F6AD00', dark: '#FFD573' },
            pressed: { light: '#DEA829', dark: '#FFDE92' },
            pressedHover: { light: '#DEA829', dark: '#FFDE92' },
            disabled: { light: '#CFCFCF', dark: '#515151' },
        },
    },
};

export type Palette = typeof palette;
